import axios from 'axios'

const API_URL = 'https://racceair.herokuapp.com'
const API_LOCAL= 'http://localhost:8080'

// Create new goal
const createProject = async (projectData, token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }

  //const response = await axios.post('https://ecologyair.herokuapp.com/api/createProject', projectData, config)
  const response = await axios.post('https://racceair.herokuapp.com/api/createProject', projectData, config)

  return response.data
}

const getPublicProject = async (projectData) => {

  //const response = await axios.post('https://ecologyair.herokuapp.com/api/createProject', projectData, config)
  const response = await axios.post(API_URL+'/api/publicProject', projectData)
  return response.data
}


const getLastProject = async () => {

  const response = await axios.post('https://racceair.herokuapp.com/api/getLastProject')

  return response.data
}


// Get user goals
const getProjects = async () => {

  const response = await axios.get('https://racceair.herokuapp.com/api/getProjects')

  return response.data
}

const getProject = async (projectData) => {

  const response = await axios.post('https://racceair.herokuapp.com/api/getProject',projectData)

  return response.data

}

// Delete user goal
const deleteProject = async (projectId, token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }

  const response = await axios.delete(API_URL + projectId, config)

  return response.data
}

const projectService = {
  createProject,
  getProjects,
  getProject,
  deleteProject,
  getPublicProject,
  getLastProject
}

export default projectService
